import { Injectable } from '@angular/core';
import { SurveyResult } from '@empathy/survey/base';

@Injectable({ providedIn: 'root' })
export class SurveyAnswerParserService {
  parseExistingAnswers(existingAnswerJson: string): SurveyResult {
    const parsedAnswers = JSON.parse(existingAnswerJson) as Record<string, unknown>;

    return Object.entries(parsedAnswers).reduce((result, [questionId, value]) => {
      result[questionId] = this.parseAnswerValue(value) as SurveyResult[string];
      return result;
    }, {} as SurveyResult);
  }

  parseAnswerValue(value: unknown): unknown {
    if (typeof value !== 'string') {
      return value;
    }

    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
}
